// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getDatabase} from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAHpWM1OEXSgcPPXZv6MrHbmLmwEEjzqMk",
  authDomain: "go-game-ba0ff.firebaseapp.com",
  projectId: "go-game-ba0ff",
  storageBucket: "go-game-ba0ff.appspot.com",
  messagingSenderId: "590220845359",
  appId: "1:590220845359:web:f20baa9d3f3b9189d441da",
  measurementId: "G-2LGXPMGK69"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getDatabase(app);